import { ConfigStatePresenter } from '@/presentation/presenters/config/configStatePresenter'
import { ConfigStateViewModel } from '@/presentation/viewmodels/config/configStateViewModel'

export function useConfigStatePresenter(
  presenter: ConfigStatePresenter = new ConfigStatePresenter(new ConfigStateViewModel())
) {
  return {
    viewMode: presenter.viewMode,
    displayLanguage: presenter.displayLanguage,
    programLanguage: presenter.programLanguage,
    editorFontSize: presenter.editorFontSize,
    windowWidth: presenter.windowWidth,
    windowHeight: presenter.windowHeight,
    isLightMode: presenter.isLightMode.bind(presenter),
    setViewMode: presenter.setViewMode.bind(presenter),
    reverseViewMode: presenter.reverseViewMode.bind(presenter),
    updateWindowSize: presenter.updateWindowSize.bind(presenter),
    setDisplayLanguage: presenter.setDisplayLanguage.bind(presenter),
    setProgramLanguage: presenter.setProgramLanguage.bind(presenter),
    setEditorFontSize: presenter.setEditorFontSize.bind(presenter),
    copyClipboard: presenter.copyClipboard.bind(presenter)
  }
}
